import { ENDPOINTS } from '@/lib/constants/endpoints'
import { httpClient } from '@/providers/httpClient'
import { isServiceError } from '@/types/error'

export async function getIsSuperadmin(): Promise<boolean> {
  const result = await httpClient.get<{ isSuperadmin: boolean }>(ENDPOINTS.AUTH.SUPERADMIN)
  if (isServiceError(result)) return false
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/no-unnecessary-boolean-literal-compare -- Defend against runtime undefined/malformed response
  return result != null && result.isSuperadmin === true
}
